export const version = "abstract-signer/5.8.0";
//# sourceMappingURL=_version.js.map